import { createSlice } from '@reduxjs/toolkit'
import notepadParts from '../../utils/constants/notepadParts'
import _ from 'lodash'

let initialState = notepadParts

export const notepadPartsSlice = createSlice({
    name: 'notepadParts',
    initialState,
    reducers: {
        setParts: (state, action) => action.payload,
        addPart: (state, action) => {
            state.push({ id: false, hash: action.payload.hash })
        },
        removePart: (state, action) => {
            state = _.remove(state, function (item) {
                return item.hash === action.payload.hash
            })
        }
    }
})

export const { setParts, addPart, removePart } = notepadPartsSlice.actions

export const selectNotepadParts = (state) => state.notepadParts

export default notepadPartsSlice.reducer
